import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import VisionBoardUsersTable from './VisionBoardUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyVisionBoardUsers } from './companyVisionBoardApi';

/**
 * Company Vision Board → Employees/Members list.
 * Every user of the current population appears (those who have never made a
 * board show dashes and sort last); a row opens their board activity.
 */
const CVisionBoardUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyVisionBoardUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vision Board — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and the boards they keep. Open a user to see
        how much they have built — never what they put on it.
      </p>

      <VisionBoardUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/self-development/vision-board/user?userId=${rowData?._id}`)}
        tableName="company_vision_board_users"
      />
    </div>
  );
};

export default CVisionBoardUsers;
